import { QuestelServicesClient, HttpMethodEnum } from '@questelservices/common';
import store from '@/store';
import { BatchEventDetailsDto } from '@/models/batch/BatchEventDetailsDto';

export class BatchEventService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '');
  }

  public async updateBatchEvent(batchEventId: Guid, batchEvent: BatchEventDetailsDto): Promise<BatchEventDetailsDto> {
    return await this.client.getData(HttpMethodEnum.Post, `/api/batchevents/${batchEventId}/update-batch-event`, batchEvent);
  }
}
